// import React, {useContext, useRef, useState, useEffect} from 'react';
// import PageHeading from "../../Component/PageHeading";
// import {useNavigate, useSearchParams} from "react-router-dom";
// import {routes} from "../../Router/route";
// import {LayoutContext} from "../../layout/context/LayoutContext";
// import {Toast} from "primereact/toast";
// import {DataTable, DataTableExpandedRows, DataTableStateEvent, DataTableValueArray} from "primereact/datatable";
// import {useFetch} from "../../layout/hooks/useFetch";
// import {tablePerPageOptions} from "../../utils/helper";
// import {paginationTemplate} from "../../utils/paginationTemplate";
// import {Column} from "primereact/column";
// import {Image} from "primereact/image";
// import {baseUrl} from "../../utils/webInfo";
// import SmallHeader from "../../Component/SmallHeader";
// import parse from "html-react-parser";
// import ActionTemplate from "../../Component/ActionTemplate";
//
// const Products = () => {
//     const {accessToken} = useContext(LayoutContext);
//     const toast = useRef<Toast | null>(null);
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const [limitData, setLimitData] = useState<number>(10);
//     const [page, setPage] = useState<number>(1);
//     const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);
//
//     const {
//         data: productData,
//         loading,
//         totalData
//     } = useFetch(`/api/product?page=${page}&size=${limitData}&sort=-id`);
//
//
//     console.log("productData", productData)
//
//
//     useEffect(() => {
//         const pageParams = searchParams.get('page');
//         if (pageParams) {
//             const pageNum = parseInt(pageParams, 10);
//             setPage(pageNum);
//         } else {
//             navigate('?page=1', {replace: true});
//             setPage(1);
//         }
//     }, [searchParams, navigate]);
//
//
//     const handlePageChange = (e: DataTableStateEvent) => {
//         setLimitData(e.rows);
//         let pages = e.first / e.rows + 1;
//         navigate(`?page=${pages}`, {replace: true});
//     };
//
//
//     const rowExpansionBodyTemplate = (data: any) => {
//         const {packSize} = data;
//         console.log("Data", data)
//         return (
//             <div className={"my-3"}>
//                 <SmallHeader text={'packSize'}/>
//                 {parse(packSize)}
//
//
//             </div>
//         );
//     };
//
//
//     return (
//         <div className="card">
//             <PageHeading title="Products" isCreate createFunction={() => {
//                 navigate(`${routes.product_create}`,);
//             }}/>
//
//
//             <DataTable
//                 value={productData}
//                 dataKey="id"
//                 className="datatable-responsive myTable"
//                 emptyMessage="No department found."
//                 rowHover={true}
//                 paginator={productData?.length > 0}
//                 loading={loading}
//                 lazy
//                 first={(page - 1) * limitData}
//                 rows={limitData}
//                 totalRecords={totalData}
//                 onPage={handlePageChange}
//                 rowsPerPageOptions={tablePerPageOptions}
//                 paginatorTemplate={paginationTemplate}
//                 expandedRows={expandedRows}
//                 onRowToggle={(e) => {
//                     setExpandedRows(e.data);
//                 }}
//                 rowExpansionTemplate={rowExpansionBodyTemplate}
//             >
//                 <Column expander style={{width: "5rem"}}/>
//                 <Column
//                     field="name"
//                     header={"Name"}
//                     body={(data) => {
//                         const {brandName, genericName, imageUrl} = data
//                         return <div className={"flex align-items-center gap-2"}>
//                             {
//                                 imageUrl ?
//                                     <Image
//                                         src={`${baseUrl?.url}${imageUrl}`}
//                                         alt="user"
//                                         height="25"
//                                         className={"w-auto"} preview/>
//                                     : <Image
//                                         src={'default.png'}
//                                         alt="user"
//                                         height="40"
//                                         className={"w-auto"} preview/>
//                             }
//                             <div>
//                                 <p className="m-0">{brandName}</p>
//                                 <p className="m-0 text-sm">{genericName}</p>
//                             </div>
//                         </div>
//                     }}
//                 />
//
//                 {/*productCode*/}
//                 <Column header={'Product Code'} field={'productCode'}/>
//
//                 <Column header={'Category Name'} body={(data) => {
//                     const {product_category} = data
//                     return <div>{product_category?.name}</div>
//                 }}/>
//
//                 <Column header={'MRP'} field={'mrp'}/>
//                 <Column header={'offer Price'} field={'offerPrice'}/>
//                 <Column header={'discount Price'} field={'discountPrice'}/>
//                 <Column
//                     header={"Action"}
//                     headerClassName={"flex justify-content-end w-full"}
//                     body={(data) => {
//                         const {id, order_status_id} = data
//                         return <ActionTemplate
//                             id={id}
//                             // name={"order information"}
//                             // accept={accept} deleteRef={deleteRef}
//                             editFunction={() => {
//                                 navigate(`update/${id}`)
//                             }}
//                             editDisable={order_status_id === 5}
//                         />
//                     }}
//                 ></Column>
//
//
//             </DataTable>
//
//
//         </div>
//     );
// };
//
// export default Products;



import React, {useContext, useRef, useState, useEffect} from 'react';
import PageHeading from "../../Component/PageHeading";
import {useNavigate, useSearchParams} from "react-router-dom";
import {routes} from "../../Router/route";
import {LayoutContext} from "../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {DataTable, DataTableExpandedRows, DataTableStateEvent, DataTableValueArray} from "primereact/datatable";
import {useFetch} from "../../layout/hooks/useFetch";
import {tablePerPageOptions} from "../../utils/helper";
import {paginationTemplate} from "../../utils/paginationTemplate";
import {Column} from "primereact/column";
import {Image} from "primereact/image";
import {baseUrl} from "../../utils/webInfo";
import SmallHeader from "../../Component/SmallHeader";
import parse from "html-react-parser";
import ActionTemplate from "../../Component/ActionTemplate";

const Products = () => {
    const {accessToken} = useContext(LayoutContext);
    const toast = useRef<Toast | null>(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [limitData, setLimitData] = useState<number>(10);
    const [page, setPage] = useState<number>(0); // Changed from 1 to 0

    const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);

    const {
        data: productData,
        loading,
        totalData
    } = useFetch(`/api/product?page=${page}&size=${limitData}&sort=-id`);


    console.log("productData", productData)


    useEffect(() => {
        const pageParams = searchParams.get('page');
        if (pageParams) {
            const pageNum = parseInt(pageParams, 10);
            setPage(pageNum - 1); // Subtract 1 to convert from URL 1-based to internal 0-based
        } else {
            navigate('?page=1', {replace: true}); // Keep URL as 1-based for user-friendliness
            setPage(0); // Internal state as 0-based
        }
    }, [searchParams, navigate]);


    const handlePageChange = (e: DataTableStateEvent) => {
        setLimitData(e.rows);
        let pages = Math.floor(e.first / e.rows) + 1; // Calculate 1-based page for URL
        navigate(`?page=${pages}`, {replace: true});
        setPage(Math.floor(e.first / e.rows)); // Set internal 0-based page
    };


    const rowExpansionBodyTemplate = (data: any) => {
        const {packSize} = data;
        console.log("Data", data)
        return (
            <div className={"my-3"}>
                <SmallHeader text={'packSize'}/>
                {parse(packSize)}


            </div>
        );
    };


    return (
        <div className="card">
            <PageHeading title="Products" isCreate createFunction={() => {
                navigate(`${routes.product_create}`,);
            }}/>


            <DataTable
                value={productData}
                dataKey="id"
                className="datatable-responsive myTable"
                emptyMessage="No department found."
                rowHover={true}
                paginator={productData?.length > 0}
                loading={loading}
                lazy
                first={page * limitData} // Calculate first row index using 0-based page
                rows={limitData}
                totalRecords={totalData}
                onPage={handlePageChange}
                rowsPerPageOptions={tablePerPageOptions}
                paginatorTemplate={paginationTemplate}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                    setExpandedRows(e.data);
                }}
                rowExpansionTemplate={rowExpansionBodyTemplate}
            >
                <Column expander style={{width: "5rem"}}/>
                <Column
                    field="name"
                    header={"Name"}
                    body={(data) => {
                        const {brandName, genericName, imageUrl} = data
                        return <div className={"flex align-items-center gap-2"}>
                            {
                                imageUrl ?
                                    <Image
                                        src={`${baseUrl?.url}${imageUrl}`}
                                        alt="user"
                                        height="25"
                                        className={"w-auto"} preview/>
                                    : <Image
                                        src={'default.png'}
                                        alt="user"
                                        height="40"
                                        className={"w-auto"} preview/>
                            }
                            <div>
                                <p className="m-0">{brandName}</p>
                                <p className="m-0 text-sm">{genericName}</p>
                            </div>
                        </div>
                    }}
                />

                {/*productCode*/}
                <Column header={'Product Code'} field={'productCode'}/>

                <Column header={'Category Name'} body={(data) => {
                    const {product_category} = data
                    return <div>{product_category?.name}</div>
                }}/>

                <Column header={'MRP'} field={'mrp'}/>
                <Column header={'offer Price'} field={'offerPrice'}/>
                <Column header={'discount Price'} field={'discountPrice'}/>
                <Column
                    header={"Action"}
                    headerClassName={"flex justify-content-end w-full"}
                    body={(data) => {
                        const {id, order_status_id} = data
                        return <ActionTemplate
                            id={id}
                            // name={"order information"}
                            // accept={accept} deleteRef={deleteRef}
                            editFunction={() => {
                                navigate(`update/${id}`)
                            }}
                            editDisable={order_status_id === 5}
                        />
                    }}
                ></Column>


            </DataTable>


        </div>
    );
};

export default Products;